import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-growing-conditions',
  templateUrl: './header-column-growing-conditions.component.html',
  styleUrls: ['./header-column-growing-conditions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnGrowingConditionsComponent extends HeaderColumnComponent {}
